import { Card } from '@mui/material';
import React from 'react';
import Texto from './Texto';
import { imagenDefault } from '@/util/Articulos';
import FavoriteIcon from '@mui/icons-material/Favorite';
import { useTranslation } from 'next-i18next';

//Definimos los tipos de datos que va a recibir el componente en forma de interfaz
interface Props {
    texto: string;
    titulo: string;
    visitas?: number;
    favoritos?: number;
    isbn?: string;
    imagenLibro?: string;
    icon?: JSX.Element;
    style?: React.CSSProperties;
}

function CardDatoHorizontal({ texto, titulo, visitas, favoritos, isbn, imagenLibro, icon, style }: Props): JSX.Element {
    const { t } = useTranslation();

    const inicialTitulo = titulo?.trim()?.charAt(0)?.toUpperCase() || 'L';
    const tieneImagenValida =
        typeof imagenLibro === 'string' &&
        imagenLibro.trim() !== '' &&
        !imagenLibro.includes(imagenDefault());

    return (
        <Card
            style={{
                width: '100%',
                borderRadius: '12px',
                boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
                ...style,
            }}
        >
            <section
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    gap: '1em',
                    padding: '1em',
                }}
            >
                <div style={{ display: 'flex', alignItems: 'center', gap: '1em', minWidth: 0, flex: 1 }}>
                    {tieneImagenValida ? (
                        <div
                            role="img"
                            aria-label={titulo}
                            style={{
                                width: '50px',
                                height: '75px',
                                borderRadius: '6px',
                                border: '1px solid #e5e5e5',
                                flexShrink: 0,
                                backgroundImage: `url(${imagenLibro})`,
                                backgroundSize: 'cover',
                                backgroundPosition: 'center',
                                backgroundRepeat: 'no-repeat',
                            }}
                        />
                    ) : (
                        <div
                            style={{
                                width: '50px',
                                height: '75px',
                                borderRadius: '6px',
                                backgroundColor: '#f2f4f7',
                                color: '#637083',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                fontWeight: 'bold',
                                border: '1px solid #e5e5e5',
                                flexShrink: 0,
                                userSelect: 'none',
                            }}
                        >
                            {icon || inicialTitulo}
                        </div>
                    )}

                    <div style={{ display: 'flex', flexDirection: 'column', minWidth: 0, gap: '0.25em', flex: 1 }}>
                        <Texto
                            style={{
                                margin: 0,
                                fontSize: '1rem',
                                fontWeight: '700',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {titulo}
                        </Texto>
                        <Texto
                            style={{
                                margin: 0,
                                fontSize: '0.9rem',
                                color: '#667085',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {texto}
                        </Texto>
                    </div>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end', gap: '0.25em', flexShrink: 0 }}>
                    {typeof visitas === 'number' && (
                        <Texto style={{ margin: 0, fontSize: '0.8rem', color: '#475467', fontWeight: '600' }}>
                            {visitas} {t("menu:secciones.estadisticas.libros.visitas_total")}
                        </Texto>
                    )}
                    {typeof favoritos === 'number' && (
                        <Texto style={{ margin: 0, fontSize: '0.8rem', color: '#475467', fontWeight: '600', display: 'flex', alignItems: 'center', gap: '0.25em' }}>
                            <FavoriteIcon style={{ fontSize: '1rem', color: '#e02424' }} />
                            {favoritos} {t("menu:secciones.estadisticas.libros.favoritos")}
                        </Texto>
                    )}
                    {isbn && (
                        <Texto style={{ margin: 0, fontSize: '0.75rem', color: '#98a2b3' }}>
                            {t("menu:secciones.estadisticas.libros.isbn")}: {isbn}
                        </Texto>
                    )}
                </div>
            </section>
        </Card>
    );
}

export default CardDatoHorizontal;
